<!-- Copyright 2023 Midas Healthcare Solutions - All Rights Reserved -->
<img src="/assets/midas{{ (theme$ | async) === 'dark' ? '_dark' : '' }}.png" alt="Midas" />
<mat-spinner color="primary" [diameter]="40"></mat-spinner>
